<template>
  <b-row class="animated fadeIn">
    <b-col cols="12" col sm="6">
      <b-card>
        <div slot="header"><i class="icon-wallet"></i> Cierre Mensual</div>
        <b-row class="mb-2">
          <b-col cols="12" col md="4">
            <date-picker
              v-model="fechaSelect"
              type="month"
              :disabled-date="notBefore"
              :editable="false"
              style="width:90%"
            >
            </date-picker>
          </b-col>
          <b-col cols="12" col md="6">
            <b-button
              pill
              size="sm"
              variant="success"
              :disabled="!fechaSelect || getCerrarMes ==0"
              @click="asentar('all')"
            >
              Proceder <i class="icon icon-lock"></i>
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <br />
        </b-row>
        <section v-show="cargando">
          <loader-ag />
          <b-row>
            <p class="text-primary mx-auto">Por favor espere...</p>
          </b-row>
        </section>
        <b-row v-show="!cargando">
          <b-col cols="12">
            <table>
              <tr>
                <td class="text-center text-info"><strong>Año</strong></td>
                <td class="text-center text-info"><strong>Mes</strong></td>
                <td></td>
              </tr>
              <tr v-for="(d, index) in items" :key="d.id">
                <td class="text-center" style="width:5em" v-text="d.anio"></td>
                <td class="text-center" style="width:10em" v-text="d.mes"></td>
                <td style="width:2em">
                  <a
                    v-show="index == 0 && currentPage == 1"
                    class="enlace text-info"
                    @click="desasentar(d.id)"
                    v-b-tooltip.hover
                    title="Re-abrir Mes"
                    ><i class="fa fa-unlock"></i
                  ></a>
                </td>
              </tr>
            </table>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="8" col sm="3">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="mt-4"
              size="sm"
              @input="getRegistros"
            ></b-pagination
          ></b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import { mapGetters } from "vuex";
import LoaderAg from "../../components/LoaderAg";
import toastr from "toastr";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";
import Vue2Filters from "vue2-filters";
import _ from "lodash";

export default {
  name: "asentar",
  mixins: [Vue2Filters.mixin],
  components: { DatePicker, LoaderAg },
  data: () => {
    return {
      cargando: false,
      fechaSelect: undefined,
      ultimoanio: undefined,
      ultimomes: undefined,
      aniomes: undefined,
      items: [],
      currentPage: 1,
      totalRows: 0,
      perPage: 12
    };
  },
  mounted() {
    this.getUltimoCierre();
  },
  methods: {
    async getUltimoCierre() {
      try {
        // eslint-disable-next-line no-undef
        let { data } = await axios.post("/api/cierre-mensual/ultimo", {
          empresa_id: this.empresaId
        });
        this.ultimoanio = data && data.anio ? data.anio : undefined;
        this.ultimomes = data && data.mes ? data.mes : undefined;
        this.getRegistros();
      } catch (error) {
        console.log(error);
      }
    },
    notBefore(date) {
      let fecha = new Date(this.ultimoanio, this.ultimomes, 1);
      return date < fecha;
    },
    async getRegistros() {
      this.items = [];
      let datos = [];
      try {
        // eslint-disable-next-line no-undef
        let { data } = await axios.post("/api/cierre-mensual/index", {
          empresa_id: this.empresaId,
          perPage: this.perPage,
          currentPage: this.currentPage
        });
        let result = data.data;
        result.map(d => {
          if (d.mes == 1) d.mes = "Enero";
          else if (d.mes == 2) d.mes = "Febrero";
          else if (d.mes == 3) d.mes = "Marzo";
          else if (d.mes == 4) d.mes = "Abril";
          else if (d.mes == 5) d.mes = "Mayo";
          else if (d.mes == 6) d.mes = "Junio";
          else if (d.mes == 7) d.mes = "Julio";
          else if (d.mes == 8) d.mes = "Agosto";
          else if (d.mes == 9) d.mes = "Septiembre";
          else if (d.mes == 10) d.mes = "Octubre";
          else if (d.mes == 11) d.mes = "Noviembre";
          else d.mes = "Diciembre";
          datos.push(d);
        });
        this.items = datos;
        this.totalRows = data.total;
      } catch (error) {
        console.log(error);
      }
    },
    asentar() {
      let cantidad = 0;
      const datos = this.aniomes.split("-");
      const filtro = {
        empresa_id: this.empresaId,
          anio: datos[0],
          mes: datos[1]
      };
      this.$swal({
        title: "🔒",
        text: "Esta segur@? de Cerrar el mes seleccionado?",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3a9d5d",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si",
        cancelButtonText: "No, Cancelar"
      }).then(result => {
        if (result.value) {
          this.cargando = true;
          // eslint-disable-next-line no-undef
          axios.post("/api/cierre-mensual/comprobar-pendientes",filtro).then( ({data}) =>{
            console.log(data);
            cantidad = data && data.cantidad ? parseInt(data.cantidad) :0;
            console.log(cantidad);
            if(cantidad > 0){
              toastr.options = {
                closeButton: true,
                debug: false,
                newestOnTop: false,
                progressBar: true,
                preventDuplicates: true,
                onclick: null,
                showDuration: "300",
                hideDuration: "1000",
                timeOut: "10000",
                extendedTimeOut: "15000",
                showEasing: "swing",
                hideEasing: "linear",
                showMethod: "fadeIn",
                hideMethod: "fadeOut"
              };
              this.cargando = false;
              toastr["error"](`🛑 Existen comprobantes pendientes de aprobación o anulación por tanto se puede realizar el cierre en el periodo seleccionado`);
              return;
            }else{
              // eslint-disable-next-line no-undef
              axios
                .post("/api/cierre-mensual/cierre", filtro)
                .then( re => {
                  const {data} = re;
                  if (data.status == "fail") {
                    this.cargando = false;
                    return toastr["error"](data.errors);
                  }
                  this.cargando = false;
                  toastr["success"]("Accion Realizada Correctamente");
                  this.fechaSelect = undefined;
                  this.aniomes = undefined;
                  this.getUltimoCierre();

                });
            }
          });

        }
      });
    },

    desasentar(id) {
      this.$swal({
        title: "🤔",
        text: "Esta segur@? de re-abrir el mes?",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si",
        cancelButtonText: "No, Cancelar"
      }).then(result => {
        if (result.value) {
          // eslint-disable-next-line no-undef
          axios.post("/api/cierre-mensual/cierre", { id }).then(res => {
            const {data} = res;
            if (data.status == "fail")
              return toastr["error"](data.errors);

              this.getUltimoCierre();
              this.$swal({
                toast: true,
                position: "top-end",
                html:
                  '<span class="text-success"> Acción realizada Correctamente</span>',
                type: "success",
                showConfirmButton: false,
                timer: 2000
              });

          });
        }
      });
    },
    cambiarFormatoFecha(date) {
      // eslint-disable-next-line no-undef
      this.aniomes = moment(date).format("YYYY-MM");
    }
  },
  computed: {
    ...mapGetters("authentication", ["empresaId", "getCerrarMes"])
  },
  watch: {
    fechaSelect: _.debounce(function(date) {
      this.cambiarFormatoFecha(date);
    }, 30)
  }
};
</script>
<style scoped>
.enlace {
  cursor: pointer;
}
table > tr > td {
  padding-top: 1.4em;
  border-bottom: solid 0.5px silver;
}
table > tr:hover {
  background-color: gainsboro;
}
</style>
